import { Text, View } from '@react-pdf/renderer'

import { styles } from '@/components/StatsExport/components/NoData/NoData.config'
import type { NoDataProps } from '@/components/StatsExport/components/NoData/NoData.types'

export function NoData({ title }: NoDataProps) {
  return (
    <View style={styles.box} wrap={false}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.textContainer}>
        <Text style={styles.text}>No data available</Text>
      </View>
    </View>
  )
}
